import React from 'react';
import PropTypes from 'prop-types';

export default function CheckboxIcon({ color }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H24V24H0V0Z" fill="white"/>
      <rect x="4" y="4" width="16" height="16" rx="2" fill="#F7F7FA" stroke={color} strokeWidth="2"/>
    </svg>
  )
}

CheckboxIcon.propTypes = {
  color: PropTypes.string
}

CheckboxIcon.defaultProps = {
  color: '#CDCADE'
}
